import React, { useState } from "react";
import { Button } from "@mui/material";
import useStyles from "./CustomPagination.styles";
import { CaretLeft, CaretRight, CaretDown } from "phosphor-react";

const CustomPagination = ({
  currentPage,
  totalPage,
  totalItem,
  handlePageChange,
  type,
}) => {
  const classes = useStyles();
  const [showPageList, setShowPageList] = useState(false);

  return (
    <div className={classes.root}>
      <span className={classes.showingNumber}>
        Showing {(currentPage - 1) * 50 + 1}
        {"  "}-{"  "}
        {currentPage * 50 >= totalItem ? totalItem : currentPage * 50} of{"  "}
        {totalItem} {type}
      </span>
      <div className={classes.buttonsAndPageNumber}>
        <span className={classes.gray}>Page : </span>
        <div
          onMouseEnter={() => setShowPageList(true)}
          onMouseLeave={() => setShowPageList(false)}
          className={classes.dropdown}
        >
          {showPageList && (
            <div className={classes.pageListContainer}>
              {Array.from({ length: totalPage }, (_, i) => i).map((page) => {
                return (
                  <div
                    key={page}
                    className={
                      currentPage === page + 1
                        ? classes.selectedPageNumber
                        : classes.singlePageNumber
                    }
                    onClick={() => {
                      handlePageChange(page + 1);
                    }}
                  >
                    <span>{page + 1}</span>
                  </div>
                );
              })}
            </div>
          )}

          <span style={{ color: "white" }}>{currentPage}</span>
          <CaretDown weight="fill" color="#FFFFFF" size={18} />
        </div>
        <span> out of {totalPage}</span>
        <div className={classes.nextAndPrev}>
          <Button
            className={classes.previous}
            onClick={() => {
              handlePageChange(currentPage - 1);
            }}
            disabled={currentPage === 1 ? true : false}
          >
            <CaretLeft size={20} />
            <span>Previous</span>
          </Button>
          <Button
            className={classes.next}
            onClick={() => {
              handlePageChange(currentPage + 1);
            }}
            disabled={currentPage === totalPage ? true : false}
          >
            <span>Next</span>
            <CaretRight size={20} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CustomPagination;
